var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategories = function SvgCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.192 10.615 12 2.731l4.808 7.884zm10.308 11q-1.722 0-2.918-1.197T13.385 17.5t1.197-2.918 2.918-1.197 2.918 1.197 1.197 2.918-1.197 2.918-2.918 1.197m-14.115-.5v-7.23h7.23v7.23zm14.115-1q1.097 0 1.857-.758.759-.759.759-1.857t-.759-1.857-1.857-.759q-1.097 0-1.857.759-.759.758-.759 1.857 0 1.097.759 1.857.759.759 1.857.759m-12.615-.5h4.23v-4.23h-4.23zm4.954-10.5h4.323L12 5.638z"
  })));
};
export default SvgCategories;